import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import {type PaymentsSourceType} from 'web-app/util/graphql/api-types';

import * as Actions from './actions';

export class PaymentsVerificationModalState extends Record<{
    readonly isVisible: boolean;
    readonly institutionId?: string;
    readonly paymentsAccountId?: string;
    readonly loading: boolean;
    readonly selectedSourceTypes: PaymentsSourceType[];
}>({
    isVisible: false,
    institutionId: undefined,
    paymentsAccountId: undefined,
    loading: false,
    selectedSourceTypes: [],
}) {}

export default makeReducer<PaymentsVerificationModalState>(
    [
        match(Actions.show, (state, {payload}) => {
            return new PaymentsVerificationModalState({
                isVisible: true,
                institutionId: payload.institutionId,
                paymentsAccountId: payload.paymentsAccountId,
                selectedSourceTypes: payload.selectedSourceTypes,
            });
        }),
        match(Actions.hide, state => {
            return state.merge({
                isVisible: false,
            });
        }),
        match(Actions.loading, state => {
            return state.merge({
                loading: true,
            });
        }),
        match(Actions.done, state => {
            return state.merge({
                loading: false,
            });
        }),
    ],
    new PaymentsVerificationModalState(),
);
